export default ({ request }) => ({
    shippingMarkListApi(data = {}) {
        return request({
            url: '/master/shippingMark/list',
            method: 'post',
            data,
        })
    },
    shippingMarkDetailApi(data = {}) {
        return request({
            url: '/master/shippingMark/detail',
            method: 'post',
            data,
        })
    },
    shippingMarkSaveApi(data = {}) {
        return request({
            url: '/master/shippingMark/save',
            method: 'post',
            data,
        })
    },
    shippingMarkDelApi(data = {}) {
        return request({
            url: '/master/shippingMark/del',
            method: 'post',
            data,
        })
    },
})